var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8135 0.261108C6.1967 0.261108 0.813477 5.64434 0.813477 12.2611C0.813477 18.8774 6.1967 24.2611 12.8135 24.2611C19.4298 24.2611 24.8135 18.8774 24.8135 12.2611C24.8135 5.64434 19.4307 0.261108 12.8135 0.261108ZM15.7978 12.6836H13.8455V19.6421H10.9525C10.9525 19.6421 10.9525 15.8399 10.9525 12.6836H9.57735V10.2242H10.9525V8.63346C10.9525 7.49417 11.4939 5.71394 13.872 5.71394L16.0158 5.72216V8.10949C16.0158 8.10949 14.7131 8.10949 14.4598 8.10949C14.2065 8.10949 13.8464 8.23613 13.8464 8.77944V10.2247H16.0506L15.7978 12.6836Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e12adc2e0ba94b90a75ec7a5515fe1d3.svg";
export { ForwardRef as ReactComponent };